export default __webpack_public_path__ + "static/shadow-15898cd5553efca73171058892fd532c.png";